import React, { useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { Pagination } from "antd";
import moment from "moment";
import { formatPrice, getCurrencySymbol } from "../../utils/currency";
import "./ag-grid-custom.css";

ModuleRegistry.registerModules([AllCommunityModule]);

const PAGE_SIZE = 100;

const TransactionDataTableAG = ({
  transactions,
  loading,
  total,
  currentPage,
  onPageChange,
}) => {
  const columnDefs = useMemo(
    () => [
      {
        field: "created",
        headerName: "Created",
        width: 120,
        pinned: "left",
        filter: "agDateColumnFilter",
        sortable: true,
        valueGetter: (params) => {
          return params.data?.createdAt ? new Date(params.data.createdAt) : null;
        },
        valueFormatter: (params) => {
          return params.value ? moment(params.value).format("l") : "";
        },
      },
      {
        field: "user",
        headerName: "User",
        width: 150,
        filter: "agTextColumnFilter",
        sortable: true,
        valueGetter: (params) => params.data?.user?.name || "",
      },
      {
        field: "email",
        headerName: "User email",
        width: 200,
        filter: "agTextColumnFilter",
        sortable: true,
        valueGetter: (params) => params.data?.user?.email || "",
      },
      {
        field: "publisher",
        headerName: "Publisher",
        width: 200,
        filter: "agTextColumnFilter",
        sortable: true,
        valueGetter: (params) => params.data?.publisher?.name || "",
      },
      {
        field: "type",
        headerName: "Type",
        width: 100,
        filter: "agTextColumnFilter",
        sortable: true,
        valueGetter: (params) => {
          const t = params.data?.type || "article";
          return t.charAt(0).toUpperCase() + t.slice(1);
        },
      },
      {
        field: "item",
        headerName: "Item",
        width: 250,
        filter: "agTextColumnFilter",
        sortable: true,
        valueGetter: (params) => params.data?.item || "",
      },
      {
        field: "transacted",
        headerName: "Transacted",
        width: 150,
        filter: "agNumberColumnFilter",
        sortable: true,
        valueGetter: (params) => params.data?.amount || 0,
        valueFormatter: (params) => {
          const cur = params.data?.currency || 'usd';
          return getCurrencySymbol(cur) + formatPrice(params.value, cur);
        },
      },
      {
        field: "fees",
        headerName: "Processing fees",
        width: 150,
        filter: "agNumberColumnFilter",
        sortable: true,
        valueGetter: (params) => params.data?.platformFee || 0,
        valueFormatter: (params) => {
          const cur = params.data?.currency || 'usd';
          return getCurrencySymbol(cur) + formatPrice(params.value, cur);
        },
      },
      {
        field: "share",
        headerName: "Rev share",
        width: 120,
        filter: "agNumberColumnFilter",
        sortable: true,
        valueGetter: (params) => params.data?.revShare || 0,
        valueFormatter: (params) => params.value + "%",
      },
      {
        field: "netRev",
        headerName: "Net rev (rev share * price)",
        width: 180,
        filter: "agNumberColumnFilter",
        sortable: true,
        valueGetter: (params) => params.data?.netRev || 0,
        valueFormatter: (params) => {
          const cur = params.data?.currency || 'usd';
          return getCurrencySymbol(cur) + formatPrice(params.value, cur);
        },
      },
    ],
    []
  );

  const defaultColDef = useMemo(
    () => ({
      resizable: true,
      filter: true,
    }),
    []
  );

  const rowData = useMemo(() => transactions || [], [transactions]);

  return (
    <div>
      <div
        className="ag-theme-alpine"
        style={{ height: "700px", width: "100%" }}
      >
        <AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          loading={loading}
          suppressMenuHide={true}
          enableCellTextSelection={true}
          ensureDomOrder={true}
        />
      </div>
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
        <Pagination
          current={currentPage + 1}
          pageSize={PAGE_SIZE}
          total={total}
          onChange={(page) => onPageChange(page - 1)}
          showSizeChanger={false}
          showTotal={(t) => `${t} transactions`}
          disabled={loading}
        />
      </div>
    </div>
  );
};

export default TransactionDataTableAG;
